import {
  ItemTypeEnumType,
  LearningKindType,
} from "@devforce/trailhead-client-gql";
import { Logger } from "@devforce/trailhead-client-logger";
import { I18n } from "@devforce/trailhead-client-locale";
import { getAssetsUrl } from "common/helpers";
import {
  l as lastActivity,
  t as timestamp,
  a as formatDuration,
} from "common/chunk_time";

var topicPlaceholder =
  "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22white%22%20style%3D%22background-color%3A%20%230070D2%3B%22%3E%20%20%3Cpath%20%20%20%20d%3D%22M18.8%208.2h-1.9l.8-3.1V5c0-.1-.1-.2-.3-.2h-1.5c-.1%200-.2.1-.2.2l-.8%203.2h-3.8l.8-3.1V5c0-.1-.1-.2-.2-.2h-1.5c-.2%200-.3.1-.3.2l-.8%203.2H7c-.2%200-.2.1-.3.2l-.4%201.4v.1c0%20.1.1.2.3.2h2l-1%203.7h-2c-.1%200-.2%200-.2.1L5%2015.4c0%20.1.1.2.2.2h1.9l-.8%203.2v.1c0%20.1.1.2.3.2h1.5c.1%200%20.2-.1.2-.2l.8-3.3h3.8l-.8%203.2c0%20.2.1.3.2.3h1.5c.2%200%20.3-.1.3-.2l.8-3.3H17c.1%200%20.2-.1.3-.2l.3-1.4v-.1c0-.1-.1-.2-.2-.2h-2l1-3.7h2c.1%200%20.2%200%20.2-.2l.4-1.4c0-.1-.1-.2-.2-.2zm-5.4%205.6H9.6l1-3.6h3.8l-1%203.6z%22%3E%20%20%3C%2Fpath%3E%3C%2Fsvg%3E";

var userPlaceholder =
  "data:image/png;base64,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";

var appExchangeIcon =
  "data:image/svg+xml,%3Csvg%20width%3D%2264%22%20height%3D%2264%22%20viewBox%3D%220%200%2064%2064%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20width%3D%2264%22%20height%3D%2264%22%20rx%3D%228%22%20fill%3D%22%23CFE9FE%22%2F%3E%3Cpath%20d%3D%22M31.9935%2017.6616C23.8677%2017.6616%2017.2305%2023.5824%2017.2305%2030.9495V31.208C17.2896%2033.0395%2017.7441%2034.8365%2018.5628%2036.4758C19.3814%2038.115%2020.5448%2039.5576%2021.9731%2040.7046L22.1699%2040.8708V40.92C21.7918%2042.0262%2021.135%2043.0161%2020.2631%2043.7942C20.0827%2043.951%2019.9581%2044.1622%2019.9082%2044.396C19.8584%2044.6298%2019.8858%2044.8735%2019.9865%2045.0903C20.0872%2045.3071%2020.2557%2045.4853%2020.4665%2045.5979C20.6773%2045.7105%2020.9189%2045.7514%2021.155%2045.7145L21.8747%2045.6099L22.2007%2045.5606C25.1287%2045.1113%2027.2017%2044.582%2028.4935%2043.9235L28.5857%2043.8743L28.8933%2043.942C29.9194%2044.1368%2030.9614%2044.2357%2032.0059%2044.2374C40.1317%2044.2374%2046.7689%2038.3166%2046.7689%2030.9495C46.7689%2023.5824%2040.1194%2017.6616%2031.9935%2017.6616Z%22%20fill%3D%22%23014486%22%2F%3E%3C%2Fsvg%3E";

var documentationIcon =
  "data:image/svg+xml,%3Csvg%20width%3D%2264%22%20height%3D%2264%22%20viewBox%3D%220%200%2064%2064%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20width%3D%2264%22%20height%3D%2264%22%20rx%3D%228%22%20fill%3D%22%23CFE9FE%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M21.8461%2037.5389H29.8461C30.3384%2037.5389%2030.7692%2037.1081%2030.7692%2036.6158V22.1538C30.7692%2021.1076%2029.6615%2020.3076%2028.7999%2020.3076H21.8461C21.3538%2020.3076%2020.923%2020.7384%2020.923%2021.2307V36.6158C20.923%2037.1081%2021.3538%2037.5389%2021.8461%2037.5389ZM46.2769%2023.1377C45.9077%2023.0147%2045.5385%2023.3224%2045.5385%2023.7531V39.0767C45.5385%2039.569%2045.1077%2039.9998%2044.6154%2039.9998H19.3846C18.8923%2039.9998%2018.4615%2039.569%2018.4615%2039.0767V23.8147C18.4615%2023.3839%2017.9692%2023.0762%2017.6%2023.2608C16.6769%2023.6916%2016%2024.6762%2016%2025.8455V39.9998C16%2041.3536%2017.1077%2042.4614%2018.4615%2042.4614H28.6154C29.1077%2042.4614%2029.5385%2042.8921%2029.5385%2043.3845C29.5385%2043.8768%2029.9692%2044.3076%2030.4615%2044.3076H33.5385C34.0308%2044.3076%2034.4615%2043.8768%2034.4615%2043.3845C34.4615%2042.8921%2034.8923%2042.4614%2035.3846%2042.4614H45.5385C46.8923%2042.4614%2048%2041.3536%2048%2039.9998V25.8455C48%2024.5532%2047.5692%2023.4454%2046.2769%2023.1377ZM34.1542%2037.5389H42.1542C42.6465%2037.5389%2043.0773%2037.1081%2043.0773%2036.6158V21.2307C43.0773%2020.7384%2042.6465%2020.3076%2042.1542%2020.3076H35.2003C34.2773%2020.3076%2033.2311%2021.1076%2033.2311%2022.1538V36.6158C33.2311%2037.1081%2033.6619%2037.5389%2034.1542%2037.5389Z%22%20fill%3D%22%23014486%22%2F%3E%3C%2Fsvg%3E";

var knownIssuesIcon =
  "data:image/svg+xml,%3Csvg%20width%3D%2264%22%20height%3D%2264%22%20viewBox%3D%220%200%2064%2064%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20width%3D%2264%22%20height%3D%2264%22%20rx%3D%228%22%20fill%3D%22%23CFE9FE%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M21.538%2018.1538C21.538%2017.6615%2021.1072%2017.2307%2020.6149%2017.2307H18.7688C18.2765%2017.2307%2017.8457%2017.6615%2017.8457%2018.1538V45.8461C17.8457%2046.3384%2018.2765%2046.7692%2018.7688%2046.7692H20.6149C21.1072%2046.7692%2021.538%2046.3384%2021.538%2045.8461V18.1538ZM45.2302%2020.7385C35.384%2025.9077%2036.4917%2015.3231%2024.6148%2019.4462C24.2455%2019.5693%2023.9994%2019.9385%2023.9994%2020.3077V34.6462C23.9994%2035.0769%2024.4301%2035.3846%2024.7994%2035.2C36.6148%2031.2616%2035.384%2042.0923%2045.6609%2036.3077C45.9686%2036.1231%2046.1532%2035.8154%2046.1532%2035.5077V21.2308C46.1532%2020.8%2045.6609%2020.4923%2045.2302%2020.7385Z%22%20fill%3D%22%23014486%22%2F%3E%3C%2Fsvg%3E";

var videoIcon =
  "data:image/svg+xml,%3Csvg%20width%3D%2264%22%20height%3D%2264%22%20viewBox%3D%220%200%2064%2064%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20width%3D%2264%22%20height%3D%2264%22%20rx%3D%228%22%20fill%3D%22%23CFE9FE%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M44.8612%2024.0616L38.092%2028.9231V25.477C38.092%2024.5539%2037.3535%2023.8154%2036.4305%2023.8154H18.892C17.9689%2023.8154%2017.2305%2024.5539%2017.2305%2025.477V38.5847C17.2305%2039.5077%2017.9689%2040.2462%2018.892%2040.2462H36.492C37.4151%2040.2462%2038.1535%2039.5077%2038.1535%2038.5847V35.2L44.8612%2040C45.292%2040.4308%2046.0305%2040.1231%2046.0305%2039.5077V24.5539C46.0305%2023.9385%2045.292%2023.6308%2044.8612%2024.0616Z%22%20fill%3D%22%23014486%22%2F%3E%3C%2Fsvg%3E";

var data$9 = {
  trailmix_pretitle: "Trailmix von %{name}",
  module_pretitle: "Modul",
  project_pretitle: "Projekt",
  superbadge_pretitle: "Superbadge",
  trail_pretitle: "Trail",
  learningpath_pretitle: "Trail",
  employeetrail_pretitle: "Privater Trail",
  job_detail_posted_on: "Gepostet am %{date}",
  location: "Standort",
  salary: "Gehalt",
  collaboration_group_pretitle: "Gruppe",
  collaboration_group_member_count_singular: "%{count} Mitglied",
  collaboration_group_member_count_plural: "%{count} Mitglieder",
  private_collaboration_group_pretitle: "Private Gruppe",
  public_collaboration_group_pretitle: "Öffentliche Gruppe",
  featured_collaboration_group_pretitle: "Vorgestellte Gruppe",
  feed_item_question_pretitle: "%{name} fragte in %{feed}",
  feed_item_likes_singular: '%{count} "Gefällt mir"-Wertung',
  feed_item_likes_plural: '%{count} "Gefällt mir"-Wertungen',
  feed_item_answers_singular: "%{count} Antwort",
  feed_item_answers_plural: "%{count} Antworten",
  feed_item_comments_singular: "%{count} Kommentar",
  feed_item_comments_plural: "%{count} Kommentare",
  feed_item_post_pretitle: "%{name} postete in %{feed}",
  feed_item_post_go_to_post: "Zum Post wechseln",
  help_docs_pretitle: "Produktdokumentation",
  ht_release_notes_documentation_c_pretitle: "Versionshinweise",
  ht_developer_documents_c_pretitle: "Entwicklerdokumentation",
  kb_getting_started_pretitle: "Erste Schritte",
  kb_knowledge_article_pretitle: "Knowledge-Artikel",
  kb_quick_starts_pretitle: "Schnelleinstieg",
  known_issue_c_pretitle: "Bekannte Probleme",
  known_issue_meta_right: "Erstellt am %{timestamp}",
  listing_c_pretitle: "AppExchange",
  requires_purchase: "Kauf erforderlich",
  topic_pretitle: "%{count} diskutieren mit",
  user_pretitle: "Profil",
  user_description: "%{role} bei %{company}",
  video_pretitle: "Video",
  th_knowledge_pretitle: "Trailhead Knowledge-Artikel",
};
data$9.trailmix_pretitle;
data$9.module_pretitle;
data$9.project_pretitle;
data$9.superbadge_pretitle;
data$9.trail_pretitle;
data$9.learningpath_pretitle;
data$9.employeetrail_pretitle;
data$9.job_detail_posted_on;
data$9.location;
data$9.salary;
data$9.collaboration_group_pretitle;
data$9.collaboration_group_member_count_singular;
data$9.collaboration_group_member_count_plural;
data$9.private_collaboration_group_pretitle;
data$9.public_collaboration_group_pretitle;
data$9.featured_collaboration_group_pretitle;
data$9.feed_item_question_pretitle;
data$9.feed_item_likes_singular;
data$9.feed_item_likes_plural;
data$9.feed_item_answers_singular;
data$9.feed_item_answers_plural;
data$9.feed_item_comments_singular;
data$9.feed_item_comments_plural;
data$9.feed_item_post_pretitle;
data$9.feed_item_post_go_to_post;
data$9.help_docs_pretitle;
data$9.ht_release_notes_documentation_c_pretitle;
data$9.ht_developer_documents_c_pretitle;
data$9.kb_getting_started_pretitle;
data$9.kb_knowledge_article_pretitle;
data$9.kb_quick_starts_pretitle;
data$9.known_issue_c_pretitle;
data$9.known_issue_meta_right;
data$9.listing_c_pretitle;
data$9.requires_purchase;
data$9.topic_pretitle;
data$9.user_pretitle;
data$9.user_description;
data$9.video_pretitle;
data$9.th_knowledge_pretitle;

var data$8 = {
  trailmix_pretitle: "Trailmix by %{name}",
  module_pretitle: "Module",
  project_pretitle: "Project",
  superbadge_pretitle: "Superbadge",
  trail_pretitle: "Trail",
  learningpath_pretitle: "Trail",
  employeetrail_pretitle: "Private Trail",
  job_detail_posted_on: "Posted %{date}",
  location: "Location",
  salary: "Salary",
  collaboration_group_pretitle: "Group",
  collaboration_group_member_count_singular: "%{count} member",
  collaboration_group_member_count_plural: "%{count} members",
  private_collaboration_group_pretitle: "Private group",
  public_collaboration_group_pretitle: "Public group",
  featured_collaboration_group_pretitle: "Featured group",
  feed_item_question_pretitle: "%{name} asked in %{feed}",
  feed_item_likes_singular: "%{count} like",
  feed_item_likes_plural: "%{count} likes",
  feed_item_answers_singular: "%{count} answer",
  feed_item_answers_plural: "%{count} answers",
  feed_item_comments_singular: "%{count} comment",
  feed_item_comments_plural: "%{count} comments",
  feed_item_post_pretitle: "%{name} posted in %{feed}",
  feed_item_post_go_to_post: "Go to Post",
  help_docs_pretitle: "Product Documentation",
  ht_release_notes_documentation_c_pretitle: "Release Notes",
  ht_developer_documents_c_pretitle: "Developer Documentation",
  kb_getting_started_pretitle: "Getting Started",
  kb_knowledge_article_pretitle: "Knowledge Article",
  kb_quick_starts_pretitle: "Quick Start",
  known_issue_c_pretitle: "Known Issues",
  known_issue_meta_right: "Created %{timestamp}",
  listing_c_pretitle: "AppExchange",
  requires_purchase: "Requires purchase",
  topic_pretitle: "%{count} discussing",
  user_pretitle: "Profile",
  user_description: "%{role} at %{company}",
  video_pretitle: "Video",
  th_knowledge_pretitle: "Trailhead Knowledge Article",
};
data$8.trailmix_pretitle;
data$8.module_pretitle;
data$8.project_pretitle;
data$8.superbadge_pretitle;
data$8.trail_pretitle;
data$8.learningpath_pretitle;
data$8.employeetrail_pretitle;
data$8.job_detail_posted_on;
data$8.location;
data$8.salary;
data$8.collaboration_group_pretitle;
data$8.collaboration_group_member_count_singular;
data$8.collaboration_group_member_count_plural;
data$8.private_collaboration_group_pretitle;
data$8.public_collaboration_group_pretitle;
data$8.featured_collaboration_group_pretitle;
data$8.feed_item_question_pretitle;
data$8.feed_item_likes_singular;
data$8.feed_item_likes_plural;
data$8.feed_item_answers_singular;
data$8.feed_item_answers_plural;
data$8.feed_item_comments_singular;
data$8.feed_item_comments_plural;
data$8.feed_item_post_pretitle;
data$8.feed_item_post_go_to_post;
data$8.help_docs_pretitle;
data$8.ht_release_notes_documentation_c_pretitle;
data$8.ht_developer_documents_c_pretitle;
data$8.kb_getting_started_pretitle;
data$8.kb_knowledge_article_pretitle;
data$8.kb_quick_starts_pretitle;
data$8.known_issue_c_pretitle;
data$8.known_issue_meta_right;
data$8.listing_c_pretitle;
data$8.requires_purchase;
data$8.topic_pretitle;
data$8.user_pretitle;
data$8.user_description;
data$8.video_pretitle;
data$8.th_knowledge_pretitle;

var data$7 = {
  trailmix_pretitle: "Trailmix de %{name}",
  module_pretitle: "Módulo",
  project_pretitle: "Proyecto",
  superbadge_pretitle: "Superbadge",
  trail_pretitle: "Ruta",
  learningpath_pretitle: "Ruta",
  employeetrail_pretitle: "Ruta privada",
  job_detail_posted_on: "Publicado el %{date}",
  location: "Ubicación",
  salary: "Sueldo",
  collaboration_group_pretitle: "Grupo",
  collaboration_group_member_count_singular: "%{count} miembro",
  collaboration_group_member_count_plural: "%{count} miembros",
  private_collaboration_group_pretitle: "Grupo privado",
  public_collaboration_group_pretitle: "Grupo público",
  featured_collaboration_group_pretitle: "Grupo destacado",
  feed_item_question_pretitle: "%{name} ha preguntado en %{feed}",
  feed_item_likes_singular: "%{count} me gusta",
  feed_item_likes_plural: "%{count} me gusta",
  feed_item_answers_singular: "%{count} respuesta",
  feed_item_answers_plural: "%{count} respuestas",
  feed_item_comments_singular: "%{count} comentario",
  feed_item_comments_plural: "%{count} comentarios",
  feed_item_post_pretitle: "%{name} ha publicado en %{feed}",
  feed_item_post_go_to_post: "Ir a publicación",
  help_docs_pretitle: "Documentación del producto",
  ht_release_notes_documentation_c_pretitle: "Notas de la versión",
  ht_developer_documents_c_pretitle: "Documentación para desarrolladores (en)",
  kb_getting_started_pretitle: "Información general",
  kb_knowledge_article_pretitle: "Artículo de conocimiento",
  kb_quick_starts_pretitle: "Inicio rápido",
  known_issue_c_pretitle: "Problemas conocidos",
  known_issue_meta_right: "Fecha de creación: %{timestamp}",
  listing_c_pretitle: "AppExchange (en)",
  requires_purchase: "Requiere una compra",
  topic_pretitle: "%{count} debatiendo",
  user_pretitle: "Perfil",
  user_description: "%{role} en %{company}",
  video_pretitle: "Vídeo",
  th_knowledge_pretitle: "Artículo de conocimiento de Trailhead",
};
data$7.trailmix_pretitle;
data$7.module_pretitle;
data$7.project_pretitle;
data$7.superbadge_pretitle;
data$7.trail_pretitle;
data$7.learningpath_pretitle;
data$7.employeetrail_pretitle;
data$7.job_detail_posted_on;
data$7.location;
data$7.salary;
data$7.collaboration_group_pretitle;
data$7.collaboration_group_member_count_singular;
data$7.collaboration_group_member_count_plural;
data$7.private_collaboration_group_pretitle;
data$7.public_collaboration_group_pretitle;
data$7.featured_collaboration_group_pretitle;
data$7.feed_item_question_pretitle;
data$7.feed_item_likes_singular;
data$7.feed_item_likes_plural;
data$7.feed_item_answers_singular;
data$7.feed_item_answers_plural;
data$7.feed_item_comments_singular;
data$7.feed_item_comments_plural;
data$7.feed_item_post_pretitle;
data$7.feed_item_post_go_to_post;
data$7.help_docs_pretitle;
data$7.ht_release_notes_documentation_c_pretitle;
data$7.ht_developer_documents_c_pretitle;
data$7.kb_getting_started_pretitle;
data$7.kb_knowledge_article_pretitle;
data$7.kb_quick_starts_pretitle;
data$7.known_issue_c_pretitle;
data$7.known_issue_meta_right;
data$7.listing_c_pretitle;
data$7.requires_purchase;
data$7.topic_pretitle;
data$7.user_pretitle;
data$7.user_description;
data$7.video_pretitle;
data$7.th_knowledge_pretitle;

var data$6 = {
  trailmix_pretitle: "Trailmix por %{name}",
  module_pretitle: "Módulo",
  project_pretitle: "Proyecto",
  superbadge_pretitle: "Superbadge",
  trail_pretitle: "Ruta",
  learningpath_pretitle: "Ruta",
  employeetrail_pretitle: "Ruta privada",
  job_detail_posted_on: "Publicado %{date}",
  location: "Ubicación",
  salary: "Salario",
  collaboration_group_pretitle: "Grupo",
  collaboration_group_member_count_singular: "%{count} miembro",
  collaboration_group_member_count_plural: "%{count} miembros",
  private_collaboration_group_pretitle: "Grupo privado",
  public_collaboration_group_pretitle: "Grupo público",
  featured_collaboration_group_pretitle: "Grupos destacados",
  feed_item_question_pretitle: "%{name} preguntó en %{feed}",
  feed_item_likes_singular: "%{count} Me gusta",
  feed_item_likes_plural: "%{count} Me gusta",
  feed_item_answers_singular: "%{count} respuesta",
  feed_item_answers_plural: "%{count} respuestas",
  feed_item_comments_singular: "%{count} comentario",
  feed_item_comments_plural: "%{count} comentarios",
  feed_item_post_pretitle: "%{name} publicó en %{feed}",
  feed_item_post_go_to_post: "Ir a publicación",
  help_docs_pretitle: "Documentación de productos",
  ht_release_notes_documentation_c_pretitle: "Notas de la versión",
  ht_developer_documents_c_pretitle:
    "Documentación para desarrolladores (inglés)",
  kb_getting_started_pretitle: "Información general",
  kb_knowledge_article_pretitle: "Artículo de conocimiento",
  kb_quick_starts_pretitle: "Inicio rápido",
  known_issue_c_pretitle: "Problemas conocidos (inglés)",
  known_issue_meta_right: "Fecha de creación: %{timestamp}",
  listing_c_pretitle: "AppExchange (inglés)",
  requires_purchase: "Compra obligatoria",
  topic_pretitle: "%{count} debatiendo",
  user_pretitle: "Perfil",
  user_description: "%{role} en %{company}",
  video_pretitle: "Video",
  th_knowledge_pretitle: "Artículo de conocimiento de Trailhead",
};
data$6.trailmix_pretitle;
data$6.module_pretitle;
data$6.project_pretitle;
data$6.superbadge_pretitle;
data$6.trail_pretitle;
data$6.learningpath_pretitle;
data$6.employeetrail_pretitle;
data$6.job_detail_posted_on;
data$6.location;
data$6.salary;
data$6.collaboration_group_pretitle;
data$6.collaboration_group_member_count_singular;
data$6.collaboration_group_member_count_plural;
data$6.private_collaboration_group_pretitle;
data$6.public_collaboration_group_pretitle;
data$6.featured_collaboration_group_pretitle;
data$6.feed_item_question_pretitle;
data$6.feed_item_likes_singular;
data$6.feed_item_likes_plural;
data$6.feed_item_answers_singular;
data$6.feed_item_answers_plural;
data$6.feed_item_comments_singular;
data$6.feed_item_comments_plural;
data$6.feed_item_post_pretitle;
data$6.feed_item_post_go_to_post;
data$6.help_docs_pretitle;
data$6.ht_release_notes_documentation_c_pretitle;
data$6.ht_developer_documents_c_pretitle;
data$6.kb_getting_started_pretitle;
data$6.kb_knowledge_article_pretitle;
data$6.kb_quick_starts_pretitle;
data$6.known_issue_c_pretitle;
data$6.known_issue_meta_right;
data$6.listing_c_pretitle;
data$6.requires_purchase;
data$6.topic_pretitle;
data$6.user_pretitle;
data$6.user_description;
data$6.video_pretitle;
data$6.th_knowledge_pretitle;

var data$5 = {
  trailmix_pretitle: "Trailmix par %{name}",
  module_pretitle: "Module",
  project_pretitle: "Projet",
  superbadge_pretitle: "Superbadge",
  trail_pretitle: "Parcours",
  learningpath_pretitle: "Parcours",
  employeetrail_pretitle: "Parcours privé",
  job_detail_posted_on: "Publié le %{date}",
  location: "Localisation",
  salary: "Salaire",
  collaboration_group_pretitle: "Groupe",
  collaboration_group_member_count_singular: "%{count} membre",
  collaboration_group_member_count_plural: "%{count} membres",
  private_collaboration_group_pretitle: "Groupe privé",
  public_collaboration_group_pretitle: "Groupe public",
  featured_collaboration_group_pretitle: "Groupe à la une",
  feed_item_question_pretitle: "%{name} a posé une question dans %{feed}",
  feed_item_likes_singular: "%{count} mention J’aime",
  feed_item_likes_plural: "%{count} mention J’aime",
  feed_item_answers_singular: "%{count} réponse",
  feed_item_answers_plural: "%{count} réponses",
  feed_item_comments_singular: "%{count} commentaire",
  feed_item_comments_plural: "%{count} commentaires",
  feed_item_post_pretitle: "%{name} a publié du contenu dans %{feed}",
  feed_item_post_go_to_post: "Accéder à la publication",
  help_docs_pretitle: "Documentation produit",
  ht_release_notes_documentation_c_pretitle: "Notes de publication",
  ht_developer_documents_c_pretitle: "Documentation du développeur (anglais)",
  kb_getting_started_pretitle: "Premiers pas",
  kb_knowledge_article_pretitle: "Article Knowledge",
  kb_quick_starts_pretitle: "Démarrage rapide",
  known_issue_c_pretitle: "Problèmes connus (anglais)",
  known_issue_meta_right: "Créé le %{timestamp}",
  listing_c_pretitle: "AppExchange (anglais)",
  requires_purchase: "Nécessite un achat",
  topic_pretitle: "%{count} personnes en discutent",
  user_pretitle: "Profil",
  user_description: "%{role} chez %{company}",
  video_pretitle: "Vidéo",
  th_knowledge_pretitle: "Article Knowledge Trailhead",
};
data$5.trailmix_pretitle;
data$5.module_pretitle;
data$5.project_pretitle;
data$5.superbadge_pretitle;
data$5.trail_pretitle;
data$5.learningpath_pretitle;
data$5.employeetrail_pretitle;
data$5.job_detail_posted_on;
data$5.location;
data$5.salary;
data$5.collaboration_group_pretitle;
data$5.collaboration_group_member_count_singular;
data$5.collaboration_group_member_count_plural;
data$5.private_collaboration_group_pretitle;
data$5.public_collaboration_group_pretitle;
data$5.featured_collaboration_group_pretitle;
data$5.feed_item_question_pretitle;
data$5.feed_item_likes_singular;
data$5.feed_item_likes_plural;
data$5.feed_item_answers_singular;
data$5.feed_item_answers_plural;
data$5.feed_item_comments_singular;
data$5.feed_item_comments_plural;
data$5.feed_item_post_pretitle;
data$5.feed_item_post_go_to_post;
data$5.help_docs_pretitle;
data$5.ht_release_notes_documentation_c_pretitle;
data$5.ht_developer_documents_c_pretitle;
data$5.kb_getting_started_pretitle;
data$5.kb_knowledge_article_pretitle;
data$5.kb_quick_starts_pretitle;
data$5.known_issue_c_pretitle;
data$5.known_issue_meta_right;
data$5.listing_c_pretitle;
data$5.requires_purchase;
data$5.topic_pretitle;
data$5.user_pretitle;
data$5.user_description;
data$5.video_pretitle;
data$5.th_knowledge_pretitle;

var data$4 = {
  trailmix_pretitle: "Trailmix di %{name}",
  module_pretitle: "Modulo",
  project_pretitle: "Progetto",
  superbadge_pretitle: "Superbadge",
  trail_pretitle: "Itinerario",
  learningpath_pretitle: "Itinerario",
  employeetrail_pretitle: "Itinerario privato",
  job_detail_posted_on: "Data pubblicazione: %{date}",
  location: "Sede",
  salary: "Retribuzione",
  collaboration_group_pretitle: "Gruppo",
  collaboration_group_member_count_singular: "%{count} membro",
  collaboration_group_member_count_plural: "%{count} membri",
  private_collaboration_group_pretitle: "Gruppo privato",
  public_collaboration_group_pretitle: "Gruppo pubblico",
  featured_collaboration_group_pretitle: "Gruppo in evidenza",
  feed_item_question_pretitle: "%{name} ha fatto una domanda in %{feed}",
  feed_item_likes_singular: "%{count} mi piace",
  feed_item_likes_plural: "%{count} mi piace",
  feed_item_answers_singular: "%{count} risposta",
  feed_item_answers_plural: "%{count} risposte",
  feed_item_comments_singular: "%{count} commento",
  feed_item_comments_plural: "%{count} commenti",
  feed_item_post_pretitle: "%{name} ha pubblicato in %{feed}",
  feed_item_post_go_to_post: "Vai al post",
  help_docs_pretitle: "Documentazione sui prodotti",
  ht_release_notes_documentation_c_pretitle: "Note di rilascio",
  ht_developer_documents_c_pretitle: "Documentazione per gli sviluppatori (en)",
  kb_getting_started_pretitle: "Introduzione",
  kb_knowledge_article_pretitle: "Articolo Knowledge",
  kb_quick_starts_pretitle: "Avvio rapido",
  known_issue_c_pretitle: "Problemi noti",
  known_issue_meta_right: "Data di creazione: %{timestamp}",
  listing_c_pretitle: "AppExchange (en)",
  requires_purchase: "Richiede l'acquisto",
  topic_pretitle: "%{count} persone partecipano alla discussione",
  user_pretitle: "Profilo",
  user_description: "%{role} presso %{company}",
  video_pretitle: "Video",
  th_knowledge_pretitle: "Articolo Knowledge su Trailhead",
};
data$4.trailmix_pretitle;
data$4.module_pretitle;
data$4.project_pretitle;
data$4.superbadge_pretitle;
data$4.trail_pretitle;
data$4.learningpath_pretitle;
data$4.employeetrail_pretitle;
data$4.job_detail_posted_on;
data$4.location;
data$4.salary;
data$4.collaboration_group_pretitle;
data$4.collaboration_group_member_count_singular;
data$4.collaboration_group_member_count_plural;
data$4.private_collaboration_group_pretitle;
data$4.public_collaboration_group_pretitle;
data$4.featured_collaboration_group_pretitle;
data$4.feed_item_question_pretitle;
data$4.feed_item_likes_singular;
data$4.feed_item_likes_plural;
data$4.feed_item_answers_singular;
data$4.feed_item_answers_plural;
data$4.feed_item_comments_singular;
data$4.feed_item_comments_plural;
data$4.feed_item_post_pretitle;
data$4.feed_item_post_go_to_post;
data$4.help_docs_pretitle;
data$4.ht_release_notes_documentation_c_pretitle;
data$4.ht_developer_documents_c_pretitle;
data$4.kb_getting_started_pretitle;
data$4.kb_knowledge_article_pretitle;
data$4.kb_quick_starts_pretitle;
data$4.known_issue_c_pretitle;
data$4.known_issue_meta_right;
data$4.listing_c_pretitle;
data$4.requires_purchase;
data$4.topic_pretitle;
data$4.user_pretitle;
data$4.user_description;
data$4.video_pretitle;
data$4.th_knowledge_pretitle;

var data$3 = {
  trailmix_pretitle: "Trailmix 作成者: %{name}",
  module_pretitle: "モジュール",
  project_pretitle: "プロジェクト",
  superbadge_pretitle: "Superbadge",
  trail_pretitle: "トレイル",
  learningpath_pretitle: "トレイル",
  employeetrail_pretitle: "非公開トレイル",
  job_detail_posted_on: "投稿日: %{date}",
  location: "場所",
  salary: "給与",
  collaboration_group_pretitle: "グループ",
  collaboration_group_member_count_singular: "%{count} 人のメンバー",
  collaboration_group_member_count_plural: "%{count} 人のメンバー",
  private_collaboration_group_pretitle: "非公開グループ",
  public_collaboration_group_pretitle: "公開グループ",
  featured_collaboration_group_pretitle: "注目のグループ",
  feed_item_question_pretitle: "%{name} が「%{feed}」で質問",
  feed_item_likes_singular: "%{count} 件のいいね!",
  feed_item_likes_plural: "%{count} 件のいいね!",
  feed_item_answers_singular: "%{count} 件の回答",
  feed_item_answers_plural: "%{count} 件の回答",
  feed_item_comments_singular: "%{count} 件のコメント",
  feed_item_comments_plural: "%{count} 件のコメント",
  feed_item_post_pretitle: "%{name} が「%{feed}」に投稿",
  feed_item_post_go_to_post: "投稿に移動",
  help_docs_pretitle: "製品ドキュメント",
  ht_release_notes_documentation_c_pretitle: "リリースノート",
  ht_developer_documents_c_pretitle: "開発者ドキュメント",
  kb_getting_started_pretitle: "はじめに",
  kb_knowledge_article_pretitle: "ナレッジ記事",
  kb_quick_starts_pretitle: "クイックスタート",
  known_issue_c_pretitle: "既知の問題",
  known_issue_meta_right: "作成日 %{timestamp}",
  listing_c_pretitle: "AppExchange",
  requires_purchase: "購入が必要",
  topic_pretitle: "%{count} 人がディスカッション中",
  user_pretitle: "プロファイル",
  user_description: "%{company} の %{role}",
  video_pretitle: "動画",
  th_knowledge_pretitle: "Trailhead のナレッジ記事",
};
data$3.trailmix_pretitle;
data$3.module_pretitle;
data$3.project_pretitle;
data$3.superbadge_pretitle;
data$3.trail_pretitle;
data$3.learningpath_pretitle;
data$3.employeetrail_pretitle;
data$3.job_detail_posted_on;
data$3.location;
data$3.salary;
data$3.collaboration_group_pretitle;
data$3.collaboration_group_member_count_singular;
data$3.collaboration_group_member_count_plural;
data$3.private_collaboration_group_pretitle;
data$3.public_collaboration_group_pretitle;
data$3.featured_collaboration_group_pretitle;
data$3.feed_item_question_pretitle;
data$3.feed_item_likes_singular;
data$3.feed_item_likes_plural;
data$3.feed_item_answers_singular;
data$3.feed_item_answers_plural;
data$3.feed_item_comments_singular;
data$3.feed_item_comments_plural;
data$3.feed_item_post_pretitle;
data$3.feed_item_post_go_to_post;
data$3.help_docs_pretitle;
data$3.ht_release_notes_documentation_c_pretitle;
data$3.ht_developer_documents_c_pretitle;
data$3.kb_getting_started_pretitle;
data$3.kb_knowledge_article_pretitle;
data$3.kb_quick_starts_pretitle;
data$3.known_issue_c_pretitle;
data$3.known_issue_meta_right;
data$3.listing_c_pretitle;
data$3.requires_purchase;
data$3.topic_pretitle;
data$3.user_pretitle;
data$3.user_description;
data$3.video_pretitle;
data$3.th_knowledge_pretitle;

var data$2 = {
  trailmix_pretitle: "%{name}의 Trailmix",
  module_pretitle: "모듈",
  project_pretitle: "프로젝트",
  superbadge_pretitle: "Superbadge",
  trail_pretitle: "트레일",
  learningpath_pretitle: "트레일",
  employeetrail_pretitle: "비공개 트레일",
  job_detail_posted_on: "게시: %{date}",
  location: "위치",
  salary: "연봉",
  collaboration_group_pretitle: "그룹",
  collaboration_group_member_count_singular: "구성원 %{count}명",
  collaboration_group_member_count_plural: "구성원 %{count}명",
  private_collaboration_group_pretitle: "비공개 그룹",
  public_collaboration_group_pretitle: "전체 공개 그룹",
  featured_collaboration_group_pretitle: "추천 그룹",
  feed_item_question_pretitle: "%{name} 님이 %{feed}에 질문했습니다",
  feed_item_likes_singular: "좋아요 %{count}개",
  feed_item_likes_plural: "좋아요 %{count}개",
  feed_item_answers_singular: "답변 %{count}개",
  feed_item_answers_plural: "답변 %{count}개",
  feed_item_comments_singular: "댓글 %{count}개",
  feed_item_comments_plural: "댓글 %{count}개",
  feed_item_post_pretitle: "%{name}님이 %{feed}에 글을 올렸습니다",
  feed_item_post_go_to_post: "게시물로 이동",
  help_docs_pretitle: "제품 문서",
  ht_release_notes_documentation_c_pretitle: "릴리스 노트",
  ht_developer_documents_c_pretitle: "개발자 문서 (영어)",
  kb_getting_started_pretitle: "시작하기",
  kb_knowledge_article_pretitle: "Knowledge 기사",
  kb_quick_starts_pretitle: "빠른 시작",
  known_issue_c_pretitle: "알려진 문제",
  known_issue_meta_right: "%{timestamp} 생성",
  listing_c_pretitle: "AppExchange (영어)",
  requires_purchase: "구매 필요",
  topic_pretitle: "토론 중인 항목 %{count}개",
  user_pretitle: "프로필",
  user_description: "%{company}의 %{role}",
  video_pretitle: "비디오",
  th_knowledge_pretitle: "Trailhead Knowledge 기사",
};
data$2.trailmix_pretitle;
data$2.module_pretitle;
data$2.project_pretitle;
data$2.superbadge_pretitle;
data$2.trail_pretitle;
data$2.learningpath_pretitle;
data$2.employeetrail_pretitle;
data$2.job_detail_posted_on;
data$2.location;
data$2.salary;
data$2.collaboration_group_pretitle;
data$2.collaboration_group_member_count_singular;
data$2.collaboration_group_member_count_plural;
data$2.private_collaboration_group_pretitle;
data$2.public_collaboration_group_pretitle;
data$2.featured_collaboration_group_pretitle;
data$2.feed_item_question_pretitle;
data$2.feed_item_likes_singular;
data$2.feed_item_likes_plural;
data$2.feed_item_answers_singular;
data$2.feed_item_answers_plural;
data$2.feed_item_comments_singular;
data$2.feed_item_comments_plural;
data$2.feed_item_post_pretitle;
data$2.feed_item_post_go_to_post;
data$2.help_docs_pretitle;
data$2.ht_release_notes_documentation_c_pretitle;
data$2.ht_developer_documents_c_pretitle;
data$2.kb_getting_started_pretitle;
data$2.kb_knowledge_article_pretitle;
data$2.kb_quick_starts_pretitle;
data$2.known_issue_c_pretitle;
data$2.known_issue_meta_right;
data$2.listing_c_pretitle;
data$2.requires_purchase;
data$2.topic_pretitle;
data$2.user_pretitle;
data$2.user_description;
data$2.video_pretitle;
data$2.th_knowledge_pretitle;

var data$1 = {
  trailmix_pretitle: "Trailmix por %{name}",
  module_pretitle: "Módulo",
  project_pretitle: "Projeto",
  superbadge_pretitle: "Superbadge",
  trail_pretitle: "Trilha",
  learningpath_pretitle: "Trilha",
  employeetrail_pretitle: "Trilha privada",
  job_detail_posted_on: "Publicado(a) em %{date}",
  location: "Localização",
  salary: "Salário",
  collaboration_group_pretitle: "Grupo",
  collaboration_group_member_count_singular: "%{count} membro",
  collaboration_group_member_count_plural: "%{count} membros",
  private_collaboration_group_pretitle: "Grupo privado",
  public_collaboration_group_pretitle: "Grupo público",
  featured_collaboration_group_pretitle: "Grupo em destaque",
  feed_item_question_pretitle: "%{name} perguntou em %{feed}",
  feed_item_likes_singular: "%{count} curtida",
  feed_item_likes_plural: "%{count} curtidas",
  feed_item_answers_singular: "%{count} resposta",
  feed_item_answers_plural: "%{count} respostas",
  feed_item_comments_singular: "%{count} comentário",
  feed_item_comments_plural: "%{count} comentários",
  feed_item_post_pretitle: "%{name} publicou em %{feed}",
  feed_item_post_go_to_post: "Ir para publicação",
  help_docs_pretitle: "Documentação do produto",
  ht_release_notes_documentation_c_pretitle: "Notas da versão",
  ht_developer_documents_c_pretitle: "Documentação do desenvolvedor (Inglês)",
  kb_getting_started_pretitle: "Conceitos básicos",
  kb_knowledge_article_pretitle: "Artigo do Knowledge",
  kb_quick_starts_pretitle: "Início rápido",
  known_issue_c_pretitle: "Problemas conhecidos (Inglês)",
  known_issue_meta_right: "Criado em %{timestamp}",
  listing_c_pretitle: "AppExchange (Inglês)",
  requires_purchase: "Requer compra",
  topic_pretitle: "%{count} discutindo",
  user_pretitle: "Perfil",
  user_description: "%{role} na %{company}",
  video_pretitle: "Vídeo",
  th_knowledge_pretitle: "Artigo do Knowledge sobre Trailhead",
};
data$1.trailmix_pretitle;
data$1.module_pretitle;
data$1.project_pretitle;
data$1.superbadge_pretitle;
data$1.trail_pretitle;
data$1.learningpath_pretitle;
data$1.employeetrail_pretitle;
data$1.job_detail_posted_on;
data$1.location;
data$1.salary;
data$1.collaboration_group_pretitle;
data$1.collaboration_group_member_count_singular;
data$1.collaboration_group_member_count_plural;
data$1.private_collaboration_group_pretitle;
data$1.public_collaboration_group_pretitle;
data$1.featured_collaboration_group_pretitle;
data$1.feed_item_question_pretitle;
data$1.feed_item_likes_singular;
data$1.feed_item_likes_plural;
data$1.feed_item_answers_singular;
data$1.feed_item_answers_plural;
data$1.feed_item_comments_singular;
data$1.feed_item_comments_plural;
data$1.feed_item_post_pretitle;
data$1.feed_item_post_go_to_post;
data$1.help_docs_pretitle;
data$1.ht_release_notes_documentation_c_pretitle;
data$1.ht_developer_documents_c_pretitle;
data$1.kb_getting_started_pretitle;
data$1.kb_knowledge_article_pretitle;
data$1.kb_quick_starts_pretitle;
data$1.known_issue_c_pretitle;
data$1.known_issue_meta_right;
data$1.listing_c_pretitle;
data$1.requires_purchase;
data$1.topic_pretitle;
data$1.user_pretitle;
data$1.user_description;
data$1.video_pretitle;
data$1.th_knowledge_pretitle;

var data = {
  trailmix_pretitle: "Trailmix 由 %{name} 创建",
  module_pretitle: "模块",
  project_pretitle: "项目",
  superbadge_pretitle: "Superbadge",
  trail_pretitle: "学习路径",
  learningpath_pretitle: "学习路径",
  employeetrail_pretitle: "专用学习路径",
  job_detail_posted_on: "发布于 %{date}",
  location: "地点",
  salary: "工资",
  collaboration_group_pretitle: "小组",
  collaboration_group_member_count_singular: "%{count} 位成员",
  collaboration_group_member_count_plural: "%{count} 位成员",
  private_collaboration_group_pretitle: "专用小组",
  public_collaboration_group_pretitle: "公用小组",
  featured_collaboration_group_pretitle: "特色小组",
  feed_item_question_pretitle: "%{name} 提问于 %{feed}",
  feed_item_likes_singular: "%{count} 个赞",
  feed_item_likes_plural: "%{count} 个赞",
  feed_item_answers_singular: "%{count} 个回答",
  feed_item_answers_plural: "%{count} 个回答",
  feed_item_comments_singular: "%{count} 个评论",
  feed_item_comments_plural: "%{count} 条评论",
  feed_item_post_pretitle: "%{name} 发布于 %{feed}",
  feed_item_post_go_to_post: "转至帖子",
  help_docs_pretitle: "产品文档",
  ht_release_notes_documentation_c_pretitle: "发行说明",
  ht_developer_documents_c_pretitle: "开发人员文档（英文）",
  kb_getting_started_pretitle: "入门",
  kb_knowledge_article_pretitle: "Knowledge 文章",
  kb_quick_starts_pretitle: "快速入门",
  known_issue_c_pretitle: "已知问题",
  known_issue_meta_right: "创建于 %{timestamp}",
  listing_c_pretitle: "AppExchange（英文）",
  requires_purchase: "需要购买",
  topic_pretitle: "%{count} 人正在讨论",
  user_pretitle: "简档",
  user_description: "%{role}，就职于 %{company}",
  video_pretitle: "视频",
  th_knowledge_pretitle: "Trailhead Knowledge 文章",
};
data.trailmix_pretitle;
data.module_pretitle;
data.project_pretitle;
data.superbadge_pretitle;
data.trail_pretitle;
data.learningpath_pretitle;
data.employeetrail_pretitle;
data.job_detail_posted_on;
data.location;
data.salary;
data.collaboration_group_pretitle;
data.collaboration_group_member_count_singular;
data.collaboration_group_member_count_plural;
data.private_collaboration_group_pretitle;
data.public_collaboration_group_pretitle;
data.featured_collaboration_group_pretitle;
data.feed_item_question_pretitle;
data.feed_item_likes_singular;
data.feed_item_likes_plural;
data.feed_item_answers_singular;
data.feed_item_answers_plural;
data.feed_item_comments_singular;
data.feed_item_comments_plural;
data.feed_item_post_pretitle;
data.feed_item_post_go_to_post;
data.help_docs_pretitle;
data.ht_release_notes_documentation_c_pretitle;
data.ht_developer_documents_c_pretitle;
data.kb_getting_started_pretitle;
data.kb_knowledge_article_pretitle;
data.kb_quick_starts_pretitle;
data.known_issue_c_pretitle;
data.known_issue_meta_right;
data.listing_c_pretitle;
data.requires_purchase;
data.topic_pretitle;
data.user_pretitle;
data.user_description;
data.video_pretitle;
data.th_knowledge_pretitle;

var locales = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  de: data$9,
  en: data$8,
  es: data$7,
  esMX: data$6,
  fr: data$5,
  it: data$4,
  ja: data$3,
  ko: data$2,
  ptBR: data$1,
  zhCN: data,
});

function buildLink({ href, text, sameTab, additionalAttrs, style }) {
  const attrPairs = [["href", href]];
  if (!sameTab) {
    attrPairs.push(["target", "_blank"]);
    attrPairs.push(["rel", "noopener"]);
  }
  if (style) {
    attrPairs.push(["style", style]);
  }
  if (additionalAttrs) {
    additionalAttrs.forEach((pair) => attrPairs.push(pair));
  }
  const attrs = attrPairs.reduce(
    (str, [name, value]) => `${str} ${name}="${value}"`,
    ""
  );
  return `<a ${attrs.trim()}><tds-sanitized-html>${text}</tds-sanitized-html></a>`;
}

const logger = new Logger({
  prefix: "[th-compoments][contentSummary] ",
});
const i18n = new I18n({
  contentSummary: locales,
});
const unifiedToLearningTypeMap = {
  [ItemTypeEnumType.BadgeType]: LearningKindType.BadgeType,
  [ItemTypeEnumType.UnitType]: LearningKindType.UnitType,
  [ItemTypeEnumType.ModuleType]: LearningKindType.ModuleType,
  [ItemTypeEnumType.ProjectType]: LearningKindType.ProjectType,
  [ItemTypeEnumType.TrailType]: LearningKindType.TrailType,
  [ItemTypeEnumType.LearningpathType]: LearningKindType.LearningpathType,
  [ItemTypeEnumType.TrailmixType]: LearningKindType.TrailmixType,
  [ItemTypeEnumType.LinkType]: LearningKindType.LinkType,
  [ItemTypeEnumType.TaskType]: LearningKindType.TaskType,
  [ItemTypeEnumType.StepType]: LearningKindType.StepType,
  [ItemTypeEnumType.SuperbadgeType]: LearningKindType.SuperbadgeType,
  // Defaults:
  [ItemTypeEnumType.CollaborationGroupType]: LearningKindType.TrailType,
  [ItemTypeEnumType.FeedItemPostType]: LearningKindType.TrailType,
  [ItemTypeEnumType.FeedItemQuestionType]: LearningKindType.TrailType,
  [ItemTypeEnumType.HelpDocsType]: LearningKindType.LinkType,
  [ItemTypeEnumType.HtDeveloperDocumentsCType]: LearningKindType.LinkType,
  [ItemTypeEnumType.HtReleaseNotesDocumentationCType]:
    LearningKindType.LinkType,
  [ItemTypeEnumType.KbGettingStartedType]: LearningKindType.LinkType,
  [ItemTypeEnumType.KbKnowledgeArticleType]: LearningKindType.LinkType,
  [ItemTypeEnumType.KbQuickStartsType]: LearningKindType.LinkType,
  [ItemTypeEnumType.KnownIssueCType]: LearningKindType.LinkType,
  [ItemTypeEnumType.ListingCType]: LearningKindType.LinkType,
  [ItemTypeEnumType.ThKnowledgeType]: LearningKindType.LinkType,
  [ItemTypeEnumType.TopicType]: LearningKindType.TrailType,
  [ItemTypeEnumType.TrailheadType]: LearningKindType.TrailType,
  [ItemTypeEnumType.UserType]: LearningKindType.TrailType,
  [ItemTypeEnumType.VideoType]: LearningKindType.LinkType,
};
function epochTimeToISOString(epochTime) {
  if (epochTime) {
    return new Date(epochTime * 1000).toISOString();
  } else {
    return "";
  }
}
function getPluralizedLabel(rootKey, count = 0) {
  let labelKey;
  if (count === 1) {
    labelKey = `${rootKey}_singular`;
  } else {
    labelKey = `${rootKey}_plural`;
  }
  return i18n.t("contentSummary", labelKey, {
    count: count || 0,
  });
}
function getDocumentationPretitleLabel(type) {
  switch (type) {
    case ItemTypeEnumType.HelpDocsType:
      return "help_docs_pretitle";
    case ItemTypeEnumType.HtDeveloperDocumentsCType:
      return "ht_developer_documents_c_pretitle";
    case ItemTypeEnumType.HtReleaseNotesDocumentationCType:
      return "ht_release_notes_documentation_c_pretitle";
    case ItemTypeEnumType.KbGettingStartedType:
      return "kb_getting_started_pretitle";
    case ItemTypeEnumType.KbQuickStartsType:
      return "kb_quick_starts_pretitle";
    case ItemTypeEnumType.KbKnowledgeArticleType:
      return "kb_knowledge_article_pretitle";
    case ItemTypeEnumType.KnownIssueCType:
      return "known_issue_c_pretitle";
    case ItemTypeEnumType.ThKnowledgeType:
      return "th_knowledge_pretitle";
    case ItemTypeEnumType.VideoType:
      return "video_pretitle";
    default:
      return "";
  }
}
function getCollaborationGroupPretitleLabel(status) {
  switch (status) {
    case "PRIVATE":
      return "private_collaboration_group_pretitle";
    case "PUBLIC":
      return "public_collaboration_group_pretitle";
    default:
      return "collaboration_group_pretitle";
  }
}
function getCollaborationMetaLeftHtml(unified) {
  const postLink = buildLink({
    href: unified.url,
    text: i18n.t("contentSummary", "feed_item_post_go_to_post"),
    sameTab: true,
    style: "color: var(--tds-color-brand); text-decoration: none;",
  });
  switch (unified.type) {
    case ItemTypeEnumType.FeedItemQuestionType:
      return `${getPluralizedLabel(
        "feed_item_likes",
        unified.likesCount
      )} • ${getPluralizedLabel("feed_item_answers", unified.commentsCount)}`;
    case ItemTypeEnumType.FeedItemPostType:
      return `${postLink} • ${getPluralizedLabel(
        "feed_item_likes",
        unified.likesCount
      )} • ${getPluralizedLabel("feed_item_comments", unified.commentsCount)}`;
    default:
      return;
  }
}
function getDocumentationMetaLeft(unified) {
  switch (unified.type) {
    case ItemTypeEnumType.HtReleaseNotesDocumentationCType:
      return unified.releaseName || undefined;
    case ItemTypeEnumType.KnownIssueCType:
      return unified.status || undefined;
    case ItemTypeEnumType.ThKnowledgeType:
      return unified.keywords ? unified.keywords.join(" • ") : undefined;
    default:
      return;
  }
}
function getDocumentationMetaRight(unified) {
  switch (unified.type) {
    case ItemTypeEnumType.VideoType:
      return (unified.secondTotal && formatDuration(unified.secondTotal)) || "";
    default:
      return;
  }
}
function getDocumentationMetaRightHtml(unified) {
  switch (unified.type) {
    case ItemTypeEnumType.KnownIssueCType:
      return buildLink({
        href: unified.url,
        text: unified.actionAt
          ? i18n.t("contentSummary", "known_issue_meta_right", {
              timestamp: timestamp(epochTimeToISOString(unified.actionAt)),
            })
          : "",
        sameTab: false,
        style: "color: var(--tds-color-meteorite);",
      });
    default:
      return;
  }
}
function getDocumentationImage(type) {
  switch (type) {
    case ItemTypeEnumType.HelpDocsType:
    case ItemTypeEnumType.HtDeveloperDocumentsCType:
    case ItemTypeEnumType.HtReleaseNotesDocumentationCType:
    case ItemTypeEnumType.KbGettingStartedType:
    case ItemTypeEnumType.KbQuickStartsType:
    case ItemTypeEnumType.KbKnowledgeArticleType:
    case ItemTypeEnumType.ThKnowledgeType:
      return getAssetsUrl(documentationIcon);
    case ItemTypeEnumType.KnownIssueCType:
      return getAssetsUrl(knownIssuesIcon);
    case ItemTypeEnumType.VideoType:
      return getAssetsUrl(videoIcon);
    default:
      return "";
  }
}
function fromLearning(learning) {
  switch (learning.type) {
    case "MODULE":
      return fromModule(learning);
    case "PROJECT":
      return fromProject(learning);
    case "SUPERBADGE":
      return fromSuperbadge(learning);
    case "TRAIL":
      return fromTrail(learning);
    case "LEARNINGPATH":
      return fromLearningPath(learning);
    case "TRAILMIX":
      return fromTrailmix(learning);
    default:
      throw new Error(`Unsupported type: "${learning.type}"`);
  }
}
function fromCommunity(community) {
  const contentType = community.type.toLowerCase();
  let avatar = community.avatar;
  if (contentType === "topic" && !avatar) {
    avatar = getAssetsUrl(topicPlaceholder);
  }
  return {
    id: community.id,
    type: contentType,
    title: community.name,
    pretitle: community.typeLocalized,
    image: avatar,
    path: community.url,
    descriptionHtml: community.description,
  };
}
function getJobSalary(minSalary, maxSalary) {
  if (minSalary && maxSalary) {
    return `${minSalary}-${maxSalary}`;
  }
  return maxSalary ?? minSalary ?? "";
}
function fromJob(job) {
  return {
    id: job.id,
    descriptionHtml: job.summary,
    path: job.url,
    pathTarget: "_blank",
    pretitle: job.company,
    title: job.title,
    type: "job",
    dynamicCtaIcon: true,
    dynamicCtaIconSymbol: "link",
    details: [
      {
        icon: "location",
        ariaHidden: "false",
        ariaLabel: i18n.t("contentSummary", "location"),
        label: job.location ?? "",
      },
      {
        icon: "money",
        ariaHidden: "false",
        ariaLabel: i18n.t("contentSummary", "salary"),
        label: getJobSalary(job.minSalary, job.maxSalary),
      },
      {
        icon: "clock",
        label: job.postedDate
          ? i18n.t("contentSummary", "job_detail_posted_on", {
              date: job.postedDate,
            })
          : "",
      },
    ].filter((detail) => !!detail.label),
  };
}
function fromLearningBase(learning) {
  return {
    color: learning.color ?? undefined,
    description: learning.description,
    id: learning.id,
    image: learning.iconUrl ?? "",
    estimatedTime: learning.minuteTotal ?? undefined,
    path: learning.url ?? undefined,
    points: learning.pointTotal ?? undefined,
    pretitle:
      "audience" in learning && learning.audience === "employee"
        ? i18n.t("contentSummary", "employeetrail_pretitle")
        : i18n.t("contentSummary", `${learning.type.toLowerCase()}_pretitle`),
    title: learning.label,
    type: learning.type.toLowerCase(),
    user: learning.progress
      ? {
          finishedAt: learning.progress.completedDate ?? undefined,
          pointsEarned: learning.progress.earnedPoints ?? undefined,
          percentageComplete: learning.progress.completedPercent ?? undefined,
          state: learning.progress.state ?? undefined,
        }
      : undefined,
  };
}
function fromModule(learning) {
  return {
    ...fromLearningBase(learning),
  };
}
function fromProject(learning) {
  return {
    ...fromLearningBase(learning),
  };
}
function fromSuperbadge(learning) {
  return {
    ...fromLearningBase(learning),
  };
}
function fromTrail(learning) {
  return {
    ...fromLearningBase(learning),
  };
}
function fromLearningPath(learning) {
  return {
    ...fromLearningBase(learning),
  };
}
function fromTrailmix(learning) {
  return {
    ...fromLearningBase(learning),
    pretitle: i18n.t("contentSummary", "trailmix_pretitle", {
      name: learning.creatorName,
    }),
  };
}
function fromUnified(unified) {
  switch (unified.type) {
    case ItemTypeEnumType.BadgeType:
    case ItemTypeEnumType.UnitType:
    case ItemTypeEnumType.ModuleType:
    case ItemTypeEnumType.ProjectType:
    case ItemTypeEnumType.TrailType:
    case ItemTypeEnumType.LearningpathType:
    case ItemTypeEnumType.LinkType:
    case ItemTypeEnumType.TaskType:
    case ItemTypeEnumType.StepType:
    case ItemTypeEnumType.SuperbadgeType:
      return fromLearningBase(unifiedToLearningType(unified));
    case ItemTypeEnumType.TrailmixType:
      return fromTrailmix(unifiedToLearningType(unified));
    case ItemTypeEnumType.CollaborationGroupType:
      return fromCollaborationGroup(unified);
    case ItemTypeEnumType.TopicType:
      return fromCollaborationTopic(unified);
    case ItemTypeEnumType.FeedItemQuestionType:
    case ItemTypeEnumType.FeedItemPostType:
      return fromCollaborationItem(unified);
    case ItemTypeEnumType.UserType:
      return fromCollaborationUser(unified);
    case ItemTypeEnumType.ListingCType:
      return fromListingItem(unified);
    case ItemTypeEnumType.HelpDocsType:
    case ItemTypeEnumType.HtDeveloperDocumentsCType:
    case ItemTypeEnumType.HtReleaseNotesDocumentationCType:
    case ItemTypeEnumType.KbGettingStartedType:
    case ItemTypeEnumType.KbQuickStartsType:
    case ItemTypeEnumType.KbKnowledgeArticleType:
    case ItemTypeEnumType.KnownIssueCType:
    case ItemTypeEnumType.ThKnowledgeType:
    case ItemTypeEnumType.VideoType:
      return fromDocumentationItem(unified);
    default:
      logger.warn(`Unsupported type: "${unified.type}"`);
      return null;
  }
}
function fromDocumentationItem(unified) {
  return {
    id: unified.id,
    type: "documentation",
    pretitle: i18n.t(
      "contentSummary",
      getDocumentationPretitleLabel(unified.type)
    ),
    title: unified.label,
    path: unified.url || "#",
    pathTarget: "_blank",
    description: unified.description,
    metaLeft: getDocumentationMetaLeft(unified),
    metaRight: getDocumentationMetaRight(unified),
    metaRightHtml: getDocumentationMetaRightHtml(unified),
    image: getDocumentationImage(unified.type),
  };
}
function fromListingItem(unified) {
  return {
    id: unified.id,
    type: "listing",
    pretitle: i18n.t("contentSummary", "listing_c_pretitle"),
    title: unified.label,
    path: unified.url || "#",
    pathTarget: "_blank",
    description: unified.description,
    metaLeftHtml: `<tds-star-rating show-label="true" rating="${unified.rating}"></tds-star-rating>`,
    metaRight:
      (!unified.free && i18n.t("contentSummary", "requires_purchase")) ||
      undefined,
    image: getAssetsUrl(appExchangeIcon),
  };
}
function fromCollaborationItem(unified) {
  const actionAt = epochTimeToISOString(unified.actionAt);
  const isQuestion = unified.type === ItemTypeEnumType.FeedItemQuestionType;
  const userLink = buildLink({
    href: unified.userProfileUrl || "",
    text: unified.userName || "",
  });
  const pretitleHtml = unified.postedIn
    ? i18n.t(
        "contentSummary",
        isQuestion ? "feed_item_question_pretitle" : "feed_item_post_pretitle",
        {
          name: userLink,
          feed: buildLink({
            href: unified.postedInUrl || "",
            text: unified.postedIn || "",
          }),
        }
      )
    : userLink;
  return {
    id: unified.id,
    type: isQuestion ? "question" : "post",
    pretitleHtml,
    title: isQuestion ? unified.label : undefined,
    path: unified.url || "#",
    descriptionHtml: unified.description,
    metaLeftHtml: getCollaborationMetaLeftHtml(unified),
    metaRightHtml: buildLink({
      href: unified.url,
      text: actionAt ? timestamp(actionAt) : "",
      sameTab: true,
      style: "color: var(--tds-color-meteorite);",
    }),
    image: unified.userImageUrl || "",
    imageAlt: unified.userName || undefined,
    imageVariant: "circle",
  };
}
function fromCollaborationGroup(unified) {
  const actionAt = epochTimeToISOString(unified.actionAt);
  return {
    id: unified.id,
    type: "group",
    pretitle: i18n.t(
      "contentSummary",
      getCollaborationGroupPretitleLabel(unified.status)
    ),
    title: unified.label,
    path: unified.url || "#",
    description: unified.description,
    metaLeft: getPluralizedLabel(
      "collaboration_group_member_count",
      unified.membersCount
    ),
    metaRight: actionAt && lastActivity(actionAt),
    image: unified.iconUrl || "",
  };
}
function fromCollaborationTopic(unified) {
  return {
    id: unified.id,
    type: "topic",
    pretitle: i18n.t("contentSummary", "topic_pretitle", {
      count: unified.discussingCount || 0,
    }),
    title: `#${unified.label}`,
    path: unified.url || "#",
    description: unified.description,
    image: unified.iconUrl || getAssetsUrl(topicPlaceholder),
    imageVariant: "circle",
  };
}
function fromCollaborationUser(unified) {
  const actionAt = epochTimeToISOString(unified.actionAt);
  let description;
  if (unified.userRole && unified.userCompany) {
    description = i18n.t("contentSummary", "user_description", {
      role: unified.userRole,
      company: unified.userCompany,
    });
  } else {
    description = unified.userRole || unified.userCompany || undefined;
  }
  return {
    id: unified.id,
    type: "person",
    pretitle: i18n.t("contentSummary", "user_pretitle"),
    title: unified.label,
    path: unified.url || "#",
    description,
    metaLeft: unified.userLocation || "",
    metaRight: actionAt && lastActivity(actionAt),
    image: unified.userImageUrl || getAssetsUrl(userPlaceholder),
    imageVariant: "circle",
  };
}
function unifiedToLearningType(unified) {
  return {
    color: unified.color,
    description: unified.description,
    iconUrl: unified.iconUrl,
    id: unified.id,
    label: unified.label,
    minuteTotal: unified.minuteTotal,
    nextMilestone: unified.nextMilestone,
    pointTotal: unified.pointTotal,
    progress: unified.progress,
    type: unifiedToLearningTypeMap[unified.type],
    url: unified.url,
    name: unified.name || "",
    creatorName: unified.creatorName,
    favorite: unified.favorite || false,
    updatedAt: `${unified.actionAt}`,
    audience: null,
  };
}
function toSentenceCase(s) {
  return s.slice(0, 1).toUpperCase() + s.slice(1).toLowerCase();
}

export {
  fromCommunity,
  fromJob,
  fromLearning,
  fromLearningBase,
  fromLearningPath,
  fromModule,
  fromProject,
  fromSuperbadge,
  fromTrail,
  fromTrailmix,
  fromUnified,
  toSentenceCase,
  unifiedToLearningType,
};
